import { Transforms, Location } from 'slate';
import { ReactEditor } from 'slate-react';
import { QuizEntity } from '../../Entities';

import { insertVoidElement } from '../../lib/commands';
import { AulaEditorContext, AulaEditorInstance } from '../../types';
import { quizType } from './quizType';

export const insertQuiz = (
  editor: AulaEditorInstance,
  location: Location,
  context?: Omit<AulaEditorContext, 'entities'>
) => {
  if (context == null) {
    throw new Error('context undefined');
  }

  const { createEntity } = context;

  const quizEntity: QuizEntity = {
    type: quizType,
    data: {},
  };
  // Create entity which we will then use
  // to store the inline item ID once the
  // quiz item has been selected. Data will
  // be empty while no selection is made.
  const entity = createEntity(quizEntity);

  // insert at the end of current block
  Transforms.select(editor, location);

  // this method updates the editor entity
  // and respond to undo/redo state of editor
  insertVoidElement(editor, {
    type: quizType,
    entity,
  });

  // This is so that we can regain focus after the option
  // has been selected via the keyboard
  setTimeout(() => {
    ReactEditor.focus(editor);
  }, 0);
};
